export async function withConflictRetry<T>(
  operation: () => Promise<T>,
  maxAttempts = 3,
): Promise<{ result: T; attempts: number }> {
  let attempt = 0;
  while (true) {
    attempt += 1;
    try {
      const result = await operation();
      return { result, attempts: attempt };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      if (!message.includes("version_conflict") || attempt >= maxAttempts) {
        throw error;
      }
      const delayMs = 2 ** (attempt - 1) * 100;
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
}
